import {
    STOCK_TAKING_CAR_MANAGEMENT_CAR_LOTS_DATA_MASTER_BEGIN,
  } from '../constants';
  
  export function getCarLotsDataMaster() {
    return (dispatch) => {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_CAR_LOTS_DATA_MASTER_BEGIN,
      })
    }
  }